// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//export const environment = {
//  production: false,
//  apiUrl: 'http://localhost:61498/api',
//  sitekey: "6LdKZ7oaAAAAAAdUidhWi0wJssTUqLeUpNVpyuSK",
//  logoURL: 'https://headlessstore.blob.core.windows.net/connectorimages/',
//  returnURL: 'https://localhost:4200/connection/New/',
//  maxlogosize: '200',
//  webhookurl: 'https://standalonehook.azurewebsites.net/api/WebhookReceiver/Request/',
//  TeamsReturnURL: 'https://localhost:4200/',

//  teamsConnectorId:84,
//  slackPublishReturnURL: 'https://localhost:4200/connection/slack-action-auth/',
//};

export const environment = {
  production: true,
  apiUrl: 'https://gatecubestagingclientapi.azurewebsites.net/api',
  logoURL: 'https://gatecubestagingstorage.blob.core.windows.net/connectorimages/',
  sitekey: "6LdKZ7oaAAAAAAdUidhWi0wJssTUqLeUpNVpyuSK",
  returnURL: 'https://gatecubestagingclient.azurewebsites.net/connection/New/',
  maxlogosize: '200',  //Size is in KB
  webhookurl: 'https://gatecubestaginghook.azurewebsites.net/api/WebhookReceiver/Request/',
  TeamsReturnURL: 'https://gatecubestagingclient.azurewebsites.net/',

  teamsConnectorId: 3,
  slackPublishReturnURL: 'https://gatecubestagingclient.azurewebsites.net/connection/slack-action-auth/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
